import { render, staticRenderFns } from "./SocialStoreSvg.vue?vue&type=template&id=133d643e&"
import script from "./SocialStoreSvg.vue?vue&type=script&lang=js&"
export * from "./SocialStoreSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports